// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.input-with-suffix {
  margin: 1px;
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  border-radius: 4px;
}
.input-with-suffix--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.input-with-suffix--error .input-with-suffix__input {
  border-right-color: var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.input-with-suffix--focused,
.input-with-suffix:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.input-with-suffix--disabled {
  opacity: 0.5;
}
.input-with-suffix__input {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  padding: 0 4px;
  border: none;
  border-right: 1px solid var(--color-border-base);
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-with-suffix__suffix {
  background-color: var(--color-input-background);
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-with-suffix--without-outline {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/input-with-suffix/InputWithSuffix.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,WAAA;EAEA,qFAAA;EDoBE,kBAAA;ACXJ;AANE;EACE,iGAAA;EACA,oDAAA;AAQJ;AAVE;EAKI,kDAAA;EACA,oDAAA;AAQN;AAJE;;ECjBA,mBAAA;EACA,4CAAA;ADyBF;AAJE;EACE,YAAA;AAMJ;AAHE;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,gDAAA;EDRA,kBAAA;ECUA,0BAAA;EACA,6BAAA;AAKJ;AAFE;EACE,+CAAA;EDfA,kBAAA;ECiBA,yBAAA;EACA,4BAAA;AAIJ;AADE;EACE,aAAA;AAGJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.input-with-suffix {\n  margin: 1px;\n\n  box-shadow: @input-box-shadow;\n  #venusUI.withBorderRadius();\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n\n    .input-with-suffix__input {\n      border-right-color: var(--color-error-shadow-base);\n      background-color: @input-bg-error;\n    }\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &__input {\n    flex-grow: 1;\n    flex-shrink: 1;\n    min-width: 0;\n    padding: 0 @layoutUnit-xs;\n    border: none;\n    border-right: 1px solid var(--color-border-base);\n    #venusUI.withBorderRadius();\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  &__suffix {\n    background-color: var(--color-input-background);\n    #venusUI.withBorderRadius();\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  &--without-outline {\n    outline: none;\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
